export function sortFloat (a, b, isAsc){
  if (isAsc === true) {
    return a.weight - b.weight
  }
  return b.weight - a.weight
}
